import { useEffect, useRef } from 'react';

import {
  restaurantDetailsDataSaveDeliveryAreas,
  restaurantDetailsImpressionDeliveryAreas,
  restaurantDetailsInteractionClickToggleDeliveryArea,
} from 'core/telemetry/avo/Avo';

export const useTelemetryDeliveryAreasImpression = () => {
  const eventSentRef = useRef(false);

  useEffect(() => {
    if (!eventSentRef.current) {
      eventSentRef.current = true;
      restaurantDetailsImpressionDeliveryAreas({ viewType: 'venue' });
    }
  }, []);
};

export const sendTelemetryToggleDeliveryArea = () => {
  restaurantDetailsInteractionClickToggleDeliveryArea({ viewType: 'venue' });
};

export const sendTelemetrySaveDeliveryAreas = () => {
  restaurantDetailsDataSaveDeliveryAreas({ viewType: 'venue' });
};
